export default __webpack_public_path__ + "static/sharing-image-2b85baa28ed429ccf3cfcdae7b870b10.jpg";